import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import Select from "react-select";
import { useEffect } from "react";



const MapackageitemCreate = ()=>{
     const [matravelpackage, setMatravelpackage ] = useState('');
     const [item, setItem ] = useState('');
     const [qty, setQty ] = useState('');
     const [unitPrice, setUnitPrice ] = useState('');
     const [total, setTotal ] = useState('');
     const [timeIn, setTimeIn ] = useState('');
     const [matravelpackageList, setMatravelpackageList] = useState([]);
     const [redirect, setRedirect] = useState(false);
     const [loading, setLoading] = useState(false);
     const [hasError, setHasError] = useState(false);
     const [errorMessage, setErrorMessage] = useState('');
     const submit = async (e)=>{
         e.preventDefault();
         const payload = {
            travelPackageId: matravelpackage,
            items: items,
        };
         const {data} = await axios.post('mapackageitemMulti', payload);
        console.log(data);

       

        setRedirect(true);
     }

     useEffect(() => {
        const fetchMatravelPackages = async () => {
           setLoading(true);
           setHasError(false);
           setErrorMessage('');
     
           try {
             const { data } = await axios.get(`maTravelPackage?page=${1}`);
             setMatravelpackageList(data.data);
               //console.log(data.data);
           } catch (error) {
             if (error.response) {
               // The request was made and the server responded with a status code
               // that falls out of the range of 2xx
               if (error.response.status === 401) {
                 setErrorMessage("Unauthorized access.");
               } else if (error.response.status === 400) {
                 setErrorMessage("Bad request. Please check your input.");
               }
               else if (error.response.status === 500) {
                 setErrorMessage("Insufficient Permissions");
               }
               else {
                 setErrorMessage("An error occurred. Please try again later.");
               }
             } else if (error.request) {
               // The request was made but no response was received
               if (error.message === "Network Error") {
                 setErrorMessage("Failed to connect to the server. Please try again later.");
               } else {
                 setErrorMessage("No response received. Please try again later.");
               }
             } else {
               // Something happened in setting up the request that triggered an Error
               setErrorMessage("An error occurred. Please try again later.");
             }
             setHasError(true);
           } finally {
             setLoading(false);
           }
         };
     
         fetchMatravelPackages();

    }, []);
    const [items, setItems] = useState([
        { item: "", qty: 0, unitPrice: 0, total: 0 },
      ]);
    
      const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = value;
    
        if (field === "qty" || field === "unitPrice") {
          const qty = parseFloat(updatedItems[index].qty) || 0;
          const unitPrice = parseFloat(updatedItems[index].unitPrice) || 0;
          updatedItems[index].total = qty * unitPrice;
        }
    
        setItems(updatedItems);
      };
    
      const addNewItem = () => {
        setItems([...items, { item: "", qty: 0, unitPrice: 0, total: 0 }]);
      };

    if(redirect){
        return <Navigate to={'/mapackageitem'} />
    }
     return (
         <Wrapper pageTitle={"New Mapackageitem"}>
            <InnerNav createLink={'/mapackageitemCreate'} listLink={'/mapackageitem'} />
            <form onSubmit={submit}>
      <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
        <label className="block text-sm mb-4">
          <span className="text-gray-700 dark:text-gray-400">Travel Package</span>
          <Select
            options={matravelpackageList.map((travelPackage) => ({
              value: travelPackage.id,
              label: `${travelPackage.name} ${travelPackage.name}`.trim(),
            }))}
            onChange={(selectedOption) =>
              setMatravelpackage(selectedOption.value)
            }
          />
        </label>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-4 gap-2 mb-3 border p-2 rounded-lg"
          >
            <input
              className="p-2 border text-sm rounded-md"
              placeholder="Item"
              value={item.item}
              onChange={(e) =>
                handleItemChange(index, "item", e.target.value)
              }
            />

            <input
              type="number"
              className="p-2 border text-sm rounded-md"
              placeholder="Qty"
              value={item.qty}
              onChange={(e) =>
                handleItemChange(index, "qty", e.target.value)
              }
            />

            <input
              type="number"
              className="p-2 border text-sm rounded-md"
              placeholder="UnitPrice"
              value={item.unitPrice}
              onChange={(e) =>
                handleItemChange(index, "unitPrice", e.target.value)
              }
            />

            <input
              type="number"
              className="p-2 border text-sm rounded-md bg-gray-100"
              placeholder="Total"
              value={item.total}
              readOnly
            />
          </div>
        ))}

        <button
          type="button"
          className="px-3 py-1 mb-4 text-sm text-white bg-green-600 rounded-lg hover:bg-green-500"
          onClick={addNewItem}
        >
          + Add Item
        </button>

        <div className="flex mt-6 text-sm">
          <button
            type="submit"
            className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white bg-blue-600 rounded-lg hover:bg-blue-500"
          >
            <FiSave />
            <span className="ml-3">Save</span>
          </button>
        </div>
      </div>
    </form>
        </Wrapper>
     );
};
export default MapackageitemCreate;